import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/AuthWrapper2/components/Login/views/LoginError.tsx
/**
* The one error surface for every screen in the login flow.
*
* atalaya has no Alert/Callout/Banner component, so this is a token-styled div —
* the same markup that was inline in LoginForm, shared so all three screens look
* identical. `role="alert"` announces the message to screen readers, which matters
* when the message is the only feedback a failed sign-in produces.
*/
function LoginError({ message }) {
	if (!message) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "bg-critical-faded p-xs text-color-critical rounded-sm font-medium",
		role: "alert",
		children: message
	});
}
//#endregion
export { LoginError };

//# sourceMappingURL=LoginError.js.map